import axiosInstance from "./api";

const checkTokenValidity = async () => {
  const token = localStorage.getItem("token");

  if (!token) {
    console.log("No token found");
    return false;
  }

  try {
    const response = await axiosInstance.get("/auth/verify-token");

     return true;
  } catch (error) {
    console.error(
      "Token verification failed:",
      error.response?.data || error.message
    );
    return false;
  }
};

export default checkTokenValidity;